import { Filter } from '../components/SubHeaderFilter/types'

export const matchFilter = (fieldVal: any, filter: Filter): boolean => {
  if (fieldVal === undefined || fieldVal === null) return false

  if (filter.fieldType === 'boolean') {
    const filterBool = filter.value === 'true' || filter.value === true
    const valBool = fieldVal === 'true' || fieldVal === true || fieldVal === 'Ativo' || fieldVal === 'Sim'
    if (filter.filterType === 'equals' || filter.filterType === 'Igual a') {
      return valBool === filterBool
    }
    if (filter.filterType === 'Diferente de' || filter.filterType === 'É diferente de') {
      return valBool !== filterBool
    }
    return true
  }

  if (filter.fieldType === 'quantity' || filter.fieldType === 'price') {
    const isObj = typeof filter.value === 'object' && filter.value !== null
    const filterNum = isObj
      ? parseFloat(String(filter.value.quantity || filter.value.price).replace(',', '.'))
      : parseFloat(String(filter.value).replace(/[^\d.,-]/g, '').replace(',', '.'))
    const valNum = typeof fieldVal === 'number' ? fieldVal : parseFloat(String(fieldVal).replace(/[^\d.,-]/g, '').replace(',', '.'))
    if (isNaN(valNum) || isNaN(filterNum)) return false

    switch (filter.filterType) {
      case 'Igual a':
      case 'equals':
        return valNum === filterNum
      case 'Diferente de':
      case 'É diferente de':
        return valNum !== filterNum
      case 'Maior que':
      case 'gt':
        return valNum > filterNum
      case 'Menor que':
      case 'lt':
        return valNum < filterNum
      case 'É maior/igual que':
      case 'gte':
        return valNum >= filterNum
      case 'É menor/igual que':
      case 'lte':
        return valNum <= filterNum
    }
    return true
  }

  if (filter.fieldType === 'number' || typeof fieldVal === 'number' || (!isNaN(Number(fieldVal)) && !isNaN(parseFloat(fieldVal)))) {
    const valNum = typeof fieldVal === 'number' ? fieldVal : parseFloat(String(fieldVal).replace(/[^\d.,-]/g, '').replace(',', '.'))
    const filterNum = typeof filter.value === 'number' ? filter.value : parseFloat(String(filter.value).replace(/[^\d.,-]/g, '').replace(',', '.'))
    if (isNaN(valNum) || isNaN(filterNum)) return false

    switch (filter.filterType) {
      case 'Igual a':
      case 'equals':
        return valNum === filterNum
      case 'Diferente de':
      case 'É diferente de':
        return valNum !== filterNum
      case 'Maior que':
      case 'gt':
        return valNum > filterNum
      case 'Menor que':
      case 'lt':
        return valNum < filterNum
      case 'Maior ou igual':
      case 'Maior ou igual a':
      case 'gte':
        return valNum >= filterNum
      case 'Menor ou igual':
      case 'Menor ou igual a':
      case 'lte':
        return valNum <= filterNum
    }
  }

  if (filter.fieldType === 'date' || filter.filterType === 'Intervalo' || filter.filterType === 'Entre' || filter.filterType === 'Antes de' || filter.filterType === 'Depois de' || filter.filterType === 'Após') {
    if ((filter.filterType === 'Intervalo' || filter.filterType === 'Entre') && filter.value && typeof filter.value === 'object') {
      const start = (filter.value as any).start ? new Date((filter.value as any).start).getTime() : null
      const end = (filter.value as any).end ? new Date((filter.value as any).end).getTime() : null
      const valTime = new Date(fieldVal).getTime()
      if (isNaN(valTime)) return false
      if (start && valTime < start) return false
      if (end && valTime > end) return false
      return true
    }
    const valTime = new Date(fieldVal).getTime()
    const filterTime = new Date(String(filter.value)).getTime()
    if (isNaN(valTime) || isNaN(filterTime)) return false

    switch (filter.filterType) {
      case 'Igual a':
      case 'equals': {
        const d1 = new Date(valTime);
        const d2 = new Date(filterTime);
        return d1.getUTCFullYear() === d2.getUTCFullYear() &&
               d1.getUTCMonth() === d2.getUTCMonth() &&
               d1.getUTCDate() === d2.getUTCDate();
      }
      case 'Diferente de':
      case 'É diferente de': {
        const d1 = new Date(valTime);
        const d2 = new Date(filterTime);
        return !(d1.getUTCFullYear() === d2.getUTCFullYear() &&
                 d1.getUTCMonth() === d2.getUTCMonth() &&
                 d1.getUTCDate() === d2.getUTCDate());
      }
      case 'Antes de':
      case 'lt':
        return valTime < filterTime
      case 'Depois de':
      case 'Após':
      case 'gt':
        return valTime > filterTime
    }
  }

  const valStr = String(fieldVal).toLowerCase().trim()
  const searchVal = String(filter.value).toLowerCase().trim()

  switch (filter.filterType) {
    case 'contains':
    case 'Contém':
    default:
      return valStr.includes(searchVal)
    case 'Não contém':
      return !valStr.includes(searchVal)
    case 'equals':
    case 'Igual a':
      return valStr === searchVal
    case 'Diferente de':
    case 'É diferente de':
      return valStr !== searchVal
    case 'startsWith':
    case 'Começa com':
      return valStr.startsWith(searchVal)
    case 'endsWith':
    case 'Termina com':
      return valStr.endsWith(searchVal)
  }
}

export const matchAllFilters = (row: Record<string, any>, filters: Filter[]): boolean => {
  if (!filters || filters.length === 0) return true

  const groupedByKey: Record<string, Filter[]> = {}
  for (const filter of filters) {
    if (!groupedByKey[filter.key]) {
      groupedByKey[filter.key] = []
    }
    groupedByKey[filter.key].push(filter)
  }

  return Object.entries(groupedByKey).every(([key, group]) => {
    const fieldVal = row[key]
    return group.some(filter => matchFilter(fieldVal, filter))
  })
}
